import React from 'react';
import { useScreenText } from '../../hooks/useScreenText';

import { CoinFlip } from './CoinFlip';
import { CtaButton } from '../CtaButton';
import { Callout } from '../Callout';
import { TeamCard } from '../TeamCard';
import { MODE_SPECS } from '../../utils/constants';

export const ChooseFirstPlayer = ({ finishSetUp, firstPlayer, setFirstPlayer, mode, teams }) => {

  // Load screen text
  const { firstPlayer: firstPlayerText } = useScreenText("setUp");

  if (!firstPlayerText) {
    return "";
  }

  // Coin flip is for show. After it's done, choose the first player randomly
  const choosePlayer = () => {
    setTimeout(() => {
      const firstPlayer = Math.floor(Math.random() * teams.length);
      setFirstPlayer(firstPlayer);
    }, 250) // give the flip animation some breathing room
  }

  return (
    <div className="first-player page-container">

      <div className="set-up__container set-up__container--outlined set-up__container--min-height">

        <h1 className="h2 first-player__title">{firstPlayerText.title}</h1>        
          
          {/* Before player order determined: coin flip */}
          {firstPlayer == null ? 

            <div className="first-player__flip-wrapper">
              <CoinFlip onFlipFinish={choosePlayer} buttonText={firstPlayerText.button} />
            </div>
          
          :
          // After player order determined: reveal first player 
            <div className="first-player__result-wrapper">
              <TeamCard active team={teams[firstPlayer]} />

              { MODE_SPECS[mode].length > 1 ?
                <Callout>{firstPlayerText.calloutText}</Callout>
              : '' }

            </div>
          
          }

      </div>

      <CtaButton onClick={finishSetUp} disabled={firstPlayer === null}>{firstPlayerText.ctaButton}</CtaButton>

    </div>
  )
  
}